// extracted by mini-css-extract-plugin
export var bcg = "background-module--bcg--SqUof";
export var heroWrapper = "background-module--hero-wrapper--FqyZO";